import { ArrowRight, Users } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'

const StudentAmbassoderProgram = () => {
    return (
        <section className="container mx-auto px-4 sm:px-6 py-8">
            <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

                {/* Left - Image (hidden on mobile) */}
                <div className="flex-1 hidden lg:flex justify-center">
                    <img
                        src="/studentambnew.png"
                        alt="Student Ambassador Program"
                        className="w-full max-w-md object-contain max-h-[350px] rounded-2xl"
                    />
                </div>

                {/* Right - Content */}
                <div className="flex-1 text-center lg:text-left">
                   

                    <h1 className="text-[20px] md:text-5xl lg:text-4xl font-bold text-gray-800 mb-3 leading-tight">
                     TACTOS   <span className="text-[#fd3e3d]"> Student Ambassador </span> 
                       Program
                    </h1>

                     <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#fd3e3d]/10 text-[#fd3e3d] text-sm font-medium mb-4">
                        <Users className="w-4 h-4" />
                      
                        <span>Lead. Inspire. Empower.</span>
                    </div>
                   

                    <p className="text-black/70 text-sm md:text-md mb-3 max-w-xl mx-auto lg:mx-0">
                        Become a TACTOS Student Ambassador and play a key role in
                        empowering young innovators across India at your institution.
                    </p>

                    <p className="text-black/70 text-sm md:text-md mb-6 max-w-xl mx-auto lg:mx-0">
                        A community leadership initiative empowering individuals to
                        represent TACTOS in their region. Ambassadors connect founders,
                        host events, and strengthen the local startup ecosystem while
                        gaining exclusive perks, visibility, mentorship, and leadership
                        exposure.
                    </p>

                    {/* CTA */}
                    <div className="flex justify-center lg:justify-start">
                        <Link
                            to="/instructions/studentambassoder"
                            className="group inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635] text-white font-semibold py-3 px-8 rounded-xl transition-all duration-300 shadow-lg shadow-[#fd3e3d]/25 hover:shadow-[#fd3e3d]/40"
                        >
                            Apply Now
                            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </Link>
                    </div>
                </div>

            </div>
        </section>
    )
}

export default StudentAmbassoderProgram
